import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['languageSelect']

  declare languageSelectTarget: HTMLSelectElement;

  connect(): void {
    $(this.languageSelectTarget).select2();
  }
}
